import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";

export const FormWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
}));

export const ServicesLink = styled("a")(() => ({
  color: theme.palette.text.secondary,
  textDecoration: "none",
}));

export const ServicesList = styled("ul")(() => ({
  listStylePosition: "inside",
  marginRight: "auto",
}));

export const PageWrapper = styled("div", { shouldForwardProp: (prop) => prop !== "hasServiceIcon" })<{
  hasServiceIcon?: boolean;
}>(({ hasServiceIcon = true }) => ({
  display: "grid",
  alignContent: "center",
  justifyContent: "center",
  justifyItems: "center",
  gridAutoFlow: "row",
  rowGap: theme.spacing(3),
  ...(hasServiceIcon && {
    "& > svg": {
      width: 300,
      height: 300,
      [theme.breakpoints.up("md")]: {
        width: 400,
        height: 400,
      },
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }),
}));
